export enum ProposalStatus {
    payment_ready = 'Payment Pending',
    order_initialised = 'Payment Pending',
    payment_initiated = 'Payment Pending',
    payment_done = 'Payment done',
    policy_ready = 'Payment done',
    pi_pending = 'Payment done',
    pi_scheduled = 'Payment done',
    pi_approved = 'Payment done',
    pi_not_scheduled_by_user = 'Payment done',
    pi_rejected = 'Payment done',
    pi_cancelled = 'Payment done',
    terminated = 'Expired',
    refund_ready = 'Payment done',
    refund_issued = 'Payment done',
    policy_issued = 'Policy Issued',
}

export enum KycStatus {
    KYC_COMPLETED = 'Done',
    KYC_RECORD_NOT_PRESENT = 'Pending',
    KYC_VERIFICATION_PENDING = 'Pending',
}

export enum OrderStatusLabel {
    'Payment Pending' = 'Payment Pending',
    'Payment Done' = 'Payment Done, KYC Pending',
    'Pending' = 'Payment Done, KYC Pending',
    'Done' = 'Payment Done, KYC Done',
    'Policy Issued' = 'Policy Issued',
    'Expired' = 'Expired',
}
